import axios from "axios"
import { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { api} from "../../utils/variables"
import { consumePendingVerificationRedirect, storeLoginRedirect } from "../../utils/loginRedirect"
import { Row, Spinner, Toast, ToastBody } from "reactstrap"

// Toast notifications
import toastr from "toastr"
import "toastr/build/toastr.min.css"

export default function VerifyUser() {
  const loc = useLocation()
  const { token } = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Configure toastr options
    toastr.options = {
      positionClass: "toast-bottom-right",
      timeOut: 5000,
      extendedTimeOut: 1000,
      closeButton: true,
      progressBar: true,
      preventDuplicates: true,
      newestOnTop: true,
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000
    }

    if (token) verify()
  }, [token])

  const verify = async () => {
    const res = await axios.get(`${api}/user/verify/${token}`)
    console.log(res)
    if (res.data?.message === "Account verified. Log in to continue") {
      // Pass success message to login via navigation state (avoid sessionStorage)
      const msg = 'Account verified successfully! You can now log in to your account.'
      try {
        // Try to get the user's email from the verification response; fall
        // back to any temporary storage set at signup so we can associate
        // the activation with the correct email even across browsers.
        const verifiedEmail = res.data?.email || res.data?.user?.email || localStorage.getItem('pendingVerificationEmail') || localStorage.getItem('registeredEmail') || localStorage.getItem('firstAttemptEmail') || ''

        // Only set the per-email first-login marker if we can determine an email.
        // Avoid setting the legacy boolean `firstLoginPrompt` without an email,
        // because that can trigger the chatbot for unrelated accounts.
        // Sign-ups started from an in-place auth modal (e.g. a shared
        // report's Unlock) parked where to return in localStorage, since this
        // verification tab is a fresh one — hand it to this tab's login
        // redirect so signing in lands them back there, not the dashboard.
        const pendingRedirect = consumePendingVerificationRedirect(verifiedEmail)
        if (pendingRedirect) storeLoginRedirect(pendingRedirect)

        if (verifiedEmail) {
          try { localStorage.setItem('firstLoginPromptEmail', verifiedEmail) } catch (e) { }
          try { localStorage.removeItem('registeredEmail') } catch (e) { }
          try { localStorage.removeItem('firstAttemptEmail') } catch (e) { }
          try { localStorage.removeItem('pendingVerificationEmail') } catch (e) { }
        }
      } catch (e) { /* ignore storage errors */ }

      try {
        navigate('/login', { state: { verificationSuccess: msg } })
      } catch (e) {
        navigate('/login')
      }
    } else {
      // Pass verification error via navigation state as fallback (avoid sessionStorage)
      const errMsg = res.data?.error || 'Verification failed. Please try again.'
      try {
        navigate('/login', { state: { verificationError: errMsg } })
      } catch (e) {
        navigate('/login')
      }
    }
    setLoading(false)
  }

  return (
    <div>
      {loading ? (
        <Row className="mt-4">
          <div className="d-flex justify-content-center">
            <Spinner size="lg" color="primary" />
          </div>
        </Row>
      ) : (
        <p></p>
      )}
    </div>
  )
}
